export default {
  dashboard: {
    greeting: "Bonjour",
    welcome: "Bienvenue sur votre tableau de bord.",
    meters: {
      addressed: "Compteurs adressés",
      eligible: "Compteurs éligibles",
      eligiblePaid: "Compteurs éligibles soldés",
      eligibleInProgress: "Compteurs éligibles en cours de paiement",
      eligibleRest: "Compteurs éligibles restant à payer",
      installed: "Compteurs installés",
      contracts: "Contrats créés",
      title: "Compteurs"
    },
    totalCollectedAmount: "Montant total collecté",
    totalContractAmount: "Montant total des contrats",
    amountFor: "Pour un montant de : {amount}"
  }
}

